import { AfterContentChecked, Component } from '@angular/core';
import { DynControlBase } from '../dyn-controls-base';
import { RxFormGroup } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-dyn-checkbox',
  templateUrl: './dyn-checkbox.component.html',
  styleUrls: ['./dyn-checkbox.component.scss', '../dyn-controls.scss']
})
export class DynCheckboxComponent extends DynControlBase implements AfterContentChecked{

  ngAfterContentChecked(): void {
    this.afterContentChecked();

    if (this.form && this.control && this.form.get(this.control.keyName)) {
      const formControl = this.form.get(this.control.keyName) as RxFormGroup;
      if (this.isReadOnly()) {
        if (!formControl.disabled) {
          formControl.disable();
        }
      } else {
        if (formControl.disabled) {
          formControl.enable();
        }
      }
    }
  }
}
